const europedata = [
    {
      name: 'Estonia',
      id: 0,
      label: 'Estonia',
      unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      type: 'eGRID subregion',
      value: 0.69,
      year: 2023,
      centroid: [25.0136, 58.5953],
    },
    {
      name: 'Poland',
      id: 1,
      label: 'Poland',
      unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      type: 'eGRID subregion',
      value: 0.614,
      year: 2023,
      centroid: [19.1451, 51.9194],
    },
    {
      name: 'Cyprus',
      id: 2,
      label: 'Cyprus',
      unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      type: 'eGRID subregion',
      value: 0.585,
      year: 2023,
      centroid: [33.4299, 35.1264],
    },
    {
      name: 'Czechia',
      id: 3,
      label: 'Czechia',
      unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      type: 'eGRID subregion',
      value: 0.44,
      year: 2023,
      centroid: [15.4729, 49.8175],
    },
    {
      name: 'Malta',
      id: 4,
      label: 'Malta',
      unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      type: 'eGRID subregion',
      value: 0.342,
      year: 2023,
      centroid: [14.3754, 35.9375],
    },
    {
      name: 'Germany',
      id: 5,
      label: 'Germany',
      unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      type: 'eGRID subregion',
      value: 0.329,
      year: 2023,
      centroid: [10.4515, 51.1657],
    },
    {
      name: 'Bulgaria',
      id: 6,
      label: 'Bulgaria',
      unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      type: 'eGRID subregion',
      value: 0.281,
      year: 2023,
      centroid: [25.4858, 42.7339],
    },
    {
      name: 'Netherlands',
      id: 7,
      label: 'Netherlands',
      unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      type: 'eGRID subregion',
      value: 0.263,
      year: 2023,
      centroid: [5.2913, 52.1326],
    },
    {
      name: 'Ireland',
      id: 8,
      label: 'Ireland',
      unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      type: 'eGRID subregion',
      value: 0.26,
      year: 2023,
      centroid: [-8.2439, 53.4129],
    },
    {
      name: 'Greece',
      id: 9,
      label: 'Greece',
      unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      type: 'eGRID subregion',
      value: 0.258,
      year: 2023,
      centroid: [21.8243, 39.0742],
    },
    {
      name: 'Romania',
      id: 10,
      label: 'Romania',
      unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      type: 'eGRID subregion',
      value: 0.234,
      year: 2023,
      centroid: [24.9668, 45.9432],
    },
    {
      name: 'Italy',
      id: 11,
      label: 'Italy',
      unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      type: 'eGRID subregion',
      value: 0.225,
      year: 2023,
      centroid: [12.5674, 41.8719],
    },
    {
      name: 'Slovenia',
      id: 12,
      label: 'Slovenia',
      unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      type: 'eGRID subregion',
      value: 0.176,
      year: 2023,
      centroid: [14.9955, 46.1512],
    },
    {
      name: 'Spain',
      id: 13,
      label: 'Spain',
      unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      type: 'eGRID subregion',
      value: 0.158,
      year: 2023,
      centroid: [-3.7492, 40.4637],
    },
    {
      name: 'Hungary',
      id: 14,
      label: 'Hungary',
      unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      type: 'eGRID subregion',
      value: 0.154,
      year: 2023,
      centroid: [19.5033, 47.1625],
    },
    {
      name: 'Belgium',
      id: 15,
      label: 'Belgium',
      unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      type: 'eGRID subregion',
      value: 0.145,
      year: 2023,
      centroid: [4.4699, 50.5039],
    },
    {
      name: 'Croatia',
      id: 16,
      label: 'Croatia',
      unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      type: 'eGRID subregion',
      value: 0.134,
      year: 2023,
      centroid: [15.2, 45.1],
    },
    {
      name: 'Lithuania',
      id: 17,
      label: 'Lithuania',
      unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      type: 'eGRID subregion',
      value: 0.124,
      year: 2023,
      centroid: [23.8813, 55.1694],
    },
    {
      name: 'Portugal',
      id: 18,
      label: 'Portugal',
      unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      type: 'eGRID subregion',
      value: 0.119,
      year: 2023,
      centroid: [-8.2245, 39.3999],
    },
    {
      name: 'Denmark',
      id: 19,
      label: 'Denmark',
      unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      type: 'eGRID subregion',
      value: 0.094,
      year: 2023,
      centroid: [9.5018, 56.2639],
    },
    {
      name: 'Austria',
      id: 20,
      label: 'Austria',
      unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      type: 'eGRID subregion',
      value: 0.085,
      year: 2023,
      centroid: [14.5501, 47.5162],
    },
    {
      name: 'Slovakia',
      id: 21,
      label: 'Slovakia',
      unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      type: 'eGRID subregion',
      value: 0.084,
      year: 2023,
      centroid: [19.699, 48.669],
    },
    {
      name: 'Latvia',
      id: 22,
      label: 'Latvia',
      unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      type: 'eGRID subregion',
      value: 0.067,
      year: 2023,
      centroid: [24.6032, 56.8796],
    },
    {
      name: 'Luxembourg',
      id: 23,
      label: 'Luxembourg',
      unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      type: 'eGRID subregion',
      value: 0.056,
      year: 2023,
      centroid: [6.1296, 49.8153],
    },
    {
      name: 'France',
      id: 24,
      label: 'France',
      unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      type: 'eGRID subregion',
      value: 0.05,
      year: 2023,
      centroid: [2.2137, 46.6034],
    },
    {
      name: 'Finland',
      id: 25,
      label: 'Finland',
      unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      type: 'eGRID subregion',
      value: 0.04,
      year: 2023,
      centroid: [25.7482, 61.9241],
    },
    {
      name: 'Sweden',
      id: 26,
      label: 'Sweden',
      unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      type: 'eGRID subregion',
      value: 0.008,
      year: 2023,
      centroid: [18.6435, 60.1282],
    },
  ]
  
  export default europedata
  